export default "__VITE_ASSET__c1f4de6b__"